(function () {
    'use strict';

    angular
        .module('wizard-english-test.services')
        .service('EventService', EventService);

    /** @ngInject */
    function EventService(HttpService) {
        return {
            getEventById,
            getEventByUrl,
        };

        // GET /events/{id}
        function getEventById(id) {
            return HttpService.get('/events/' + id);
        }

        // GET /events/url/{url}
        function getEventByUrl(url) {
            return HttpService.get('/events/url/' + url);
        }
    }
}());
